import React from "react";
import { Card, CardContent } from "./ui/card";
import { Badge } from "./ui/badge";
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "./ui/accordion";
import { HelpCircle } from "lucide-react";
import { faqs } from "../mock";
import { useEnquiry } from "./EnquiryContext";

export const FAQ = () => {
  const { openEnquiryModal } = useEnquiry();

  return (
    <section id="faq" className="py-20 bg-gradient-to-b from-gray-50 to-white">
      <div className="container mx-auto px-4">
        <div className="max-w-4xl mx-auto">
          {/* Header */}
          <div className="text-center mb-12">
            <Badge className="mb-4 bg-orange-100 text-orange-700 hover:bg-orange-200">
              <HelpCircle className="h-4 w-4 mr-2" />
              Got Questions?
            </Badge>
            <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4">
              Frequently Asked Questions
            </h2>
            <div className="w-24 h-1 bg-orange-500 mx-auto mb-6"></div>
            <p className="text-xl text-gray-600">
              Clear answers to help you make an informed decision
            </p>
          </div>

          {/* FAQ Accordion */}
          <Card className="border-2 border-teal-200 shadow-xl">
            <CardContent className="pt-6">
              <Accordion type="single" collapsible className="w-full">
                {faqs.map((faq, index) => (
                  <AccordionItem key={index} value={`item-${index}`}>
                    <AccordionTrigger className="text-left hover:text-teal-700">
                      <span className="font-semibold text-gray-900">{faq.question}</span>
                    </AccordionTrigger>
                    <AccordionContent>
                      <p className="text-gray-700 leading-relaxed">{faq.answer}</p>
                    </AccordionContent>
                  </AccordionItem>
                ))}
              </Accordion>
            </CardContent>
          </Card>

          {/* Still Have Questions CTA */}
          <Card className="mt-8 border-none shadow-lg bg-gradient-to-r from-teal-600 to-teal-700">
            <CardContent className="pt-8 pb-8 text-center text-white">
              <h3 className="text-2xl font-bold mb-3">Still Have Questions?</h3>
              <p className="text-teal-50 mb-6">
                Our friendly team is here to help. Get in touch and we'll answer any questions you have.
              </p>
              <div className="flex flex-wrap justify-center gap-4">
                <a
                  href="tel:01516775573"
                  className="inline-flex items-center px-6 py-3 bg-orange-500 hover:bg-orange-600 text-white font-semibold rounded-md transition-colors"
                >
                  Call 0151 677 5573
                </a>
                <button
                  onClick={() => openEnquiryModal("general")}
                  className="inline-flex items-center px-6 py-3 bg-white/10 backdrop-blur-sm border-2 border-white text-white hover:bg-white hover:text-teal-700 font-semibold rounded-md transition-colors"
                  data-testid="faq-send-enquiry-btn"
                >
                  Send Enquiry
                </button>
              </div>
            </CardContent>
          </Card>
        </div>
      </div>
    </section>
  );
};
